import { IonCol, IonGrid, IonRow, isPlatform } from '@ionic/react';
import { ReactElement } from 'react';

interface DownloadAppInternalProps {
  href: string;
  src: string;
}

interface DownloadAppProps {
  forceShow?: boolean;
  hideiOS?: boolean;
  hideAndroid?: boolean;
}

const DownloadAppInternal = (props: DownloadAppInternalProps): ReactElement => {
  const { href, src } = props;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <img className="app-store-icon" src={src} alt={'Beacon App Download'} />
    </a>
  );
};

const DownloadGooglePlay = (): ReactElement => {
  return (
    <DownloadAppInternal
      href="https://play.google.com/store/apps/details?id=com.hirebotics.beacon&hl=en_US"
      src="/assets/email/97241599049425044.png"
    />
  );
};

const DownloadAppStore = (): ReactElement => {
  return (
    <DownloadAppInternal
      href="https://apps.apple.com/us/app/id1527810361"
      src="/assets/email/1761599049413308.png"
    />
  );
};

const DownloadApp = (props: DownloadAppProps): ReactElement | null => {
  const { forceShow, hideiOS, hideAndroid } = props;
  if (forceShow) {
    return (
      <IonGrid>
        <IonRow>
          {!hideiOS && (
            <IonCol className="ion-align-self-end ion-text-md-right ion-text-center">
              <DownloadAppStore />
            </IonCol>
          )}
          {!hideAndroid && (
            <IonCol className="ion-align-self-start ion-text-md-left ion-text-center">
              <DownloadGooglePlay />
            </IonCol>
          )}
        </IonRow>
      </IonGrid>
    );
  } else {
    if (isPlatform('mobileweb')) {
      let DownloadComponent;
      if (isPlatform('android')) {
        DownloadComponent = DownloadGooglePlay;
      } else if (isPlatform('ios')) {
        DownloadComponent = DownloadAppStore;
      }

      if (DownloadComponent) {
        return (
          <div className="full-width ion-padding">
            <DownloadComponent />
          </div>
        );
      }
    }
  }

  return null;
};

export { DownloadApp, DownloadAppStore, DownloadGooglePlay };
